<template>
    <div>
        <v-dialog
            transition="dialog-bottom-transition"
            v-model="dialog"
            scrollable
            persistent
            max-width="500"
        >
            <v-card flat>
                <v-toolbar flat dense dark color="teal">
                    <v-toolbar-title> Initialiser Solde</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid>
                        <v-form ref="form" lazy-validation>
                            <v-row dense>
                                <v-col cols="12">
                                    <strong>{{ $t('module.balance') }} *</strong>
                                    <str-balance-autocomplete
                                        v-model="balanceId"
                                        :rules="[mxRules.required]"
                                    ></str-balance-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <strong>Jointer Fichier Excel *</strong>
                                    <v-file-input
                                        v-model="file"
                                        label=""
                                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        outlined
                                        dense
                                        :prepend-icon="''"
                                        :prepend-inner-icon="'mdi-paperclip'"
                                        :color="inputColor"
                                        :background-color="backgroundColor"
                                        clearable
                                        hide-details="auto"
                                        :rules="[mxRules.required]"
                                    ></v-file-input>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn outlined depressed color="teal" @click="$router.go(-1)">
                        {{ $t("common.close") }}
                        <v-icon right>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                        dark
                        :loading="loading"
                        depressed
                        color="teal"
                        @click="init"
                    >
                        Initialiser
                        <v-icon right>mdi-cash-register</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData.js";
import useValidation from "@/use/Validation.js";
import useTools from "@/use/Tools.js";
import {ref} from "vue";
import StrBalanceAutocomplete from "@/views/Absence/Balance/Components/StrBalanceAutocomplete.vue";
import axios from "axios";

export default {
    components: {StrBalanceAutocomplete},
    setup() {
        const {$refs} = useTools();
        const {mxRules} = useValidation();
        const {dialog, loading, inputColor, backgroundColor} = useSharedData();

        const file = ref(null);
        const balanceId = ref(null);

        function init() {
            if ($refs.form.validate()) {
                loading.value = true;
                const formData = new FormData();
                formData.append("file", file.value);
                axios.post(`/workerBalances/initBalance`, formData, {
                    params: {
                        balanceId: balanceId.value,
                    },
                }).then(() => {
                    // $router.push({name: "worker_balances"});
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            mxRules,
            dialog,
            loading,
            inputColor,
            backgroundColor,
            file,
            balanceId,
            init,
        }
    },
};
</script>